<template>
  <tr class="label-inp">
    <td class="flex style-l">
      <div class="font-bold w-1/2">{{title}}</div>
      <div class="ml-4 category">
        {{category}}
      </div>
    </td>
    <td class="data">
      {{data}}
    </td>
  </tr>
</template>

<script>
export default {
  name: 'Input',
  props: ['title', 'category', 'data']
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>